import script from "./mobile-kebab-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobile-kebab-menu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__